import React, { useState, useEffect } from 'react';

const MODULE_LABELS = {
  opo_landing: 'OPO Landing',
  ai_navigation: 'AI Navigation',
  mcp: 'MCP Assistant',
  optilaw: 'OptiLaw',
  admin_ai: 'Admin AI',
  calendar: 'Calendar AI',
  property_mgr: 'Property Mgr AI'
};

const OPOActivityTab = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [moduleFilter, setModuleFilter] = useState('');
  const [days, setDays] = useState(30);
  const [offset, setOffset] = useState(0);
  const limit = 25;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams({ limit, offset, days });
        if (moduleFilter) params.set('module', moduleFilter);
        const res = await fetch(`/api/opo/activity?${params}`);
        if (res.ok) setData(await res.json());
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [moduleFilter, days, offset]);

  const summary = data?.summary || {};
  const activities = data?.activities || [];
  const total = data?.total ?? 0;

  return (
    <div className="opo-activity-tab">
      <div className="opo-activity-header">
        <div className="opo-activity-filters">
          <label>
            Module:
            <select value={moduleFilter} onChange={(e) => { setModuleFilter(e.target.value); setOffset(0); }}>
              <option value="">All</option>
              {Object.entries(MODULE_LABELS).map(([k, v]) => (
                <option key={k} value={k}>{v}</option>
              ))}
            </select>
          </label>
          <label>
            Days:
            <select value={days} onChange={(e) => { setDays(Number(e.target.value)); setOffset(0); }}>
              <option value={7}>7</option>
              <option value={30}>30</option>
              <option value={90}>90</option>
            </select>
          </label>
        </div>
        <span className="opo-last-update">Last updated: {data?.lastUpdate ? new Date(data.lastUpdate).toLocaleString() : '—'}</span>
      </div>

      <div className="opo-activity-summary">
        <div className="opo-summary-card"><span>24h</span><strong>{summary.total24h ?? 0}</strong></div>
        <div className="opo-summary-card"><span>7 days</span><strong>{summary.total7d ?? 0}</strong></div>
        <div className="opo-summary-card"><span>30 days</span><strong>{summary.total30d ?? 0}</strong></div>
        {Object.keys(summary.byModule || {}).length > 0 && (
          <div className="opo-summary-by-module">
            {Object.entries(summary.byModule).map(([mod, count]) => (
              <span key={mod} className="opo-module-badge">{MODULE_LABELS[mod] || mod}: {count}</span>
            ))}
          </div>
        )}
      </div>

      {loading ? (
        <div className="opo-loading-container"><div className="opo-loading-spinner" /></div>
      ) : (
        <>
          <div className="opo-activity-feed">
            <table className="opo-activity-table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Module</th>
                  <th>User</th>
                  <th>Agent</th>
                  <th>Messages</th>
                  <th>Preview</th>
                </tr>
              </thead>
              <tbody>
                {activities.map((a) => (
                  <tr key={a.id}>
                    <td>{a.timestamp ? new Date(a.timestamp).toLocaleString() : '—'}</td>
                    <td><span className="opo-module-badge">{a.moduleLabel || a.module}</span></td>
                    <td>{a.userDisplay ?? '—'}</td>
                    <td>{a.agent ?? '—'}</td>
                    <td>{a.messageCount ?? 0}</td>
                    <td className="opo-preview">{a.preview ? String(a.preview).slice(0, 60) + (a.preview.length > 60 ? '…' : '') : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {activities.length === 0 && <p className="opo-empty">No activity in the selected period.</p>}
          </div>
          <div className="opo-activity-pagination">
            <button type="button" disabled={offset === 0} onClick={() => setOffset(Math.max(0, offset - limit))}>Previous</button>
            <span>Showing {offset + 1}–{Math.min(offset + limit, total)} of {total}</span>
            <button type="button" disabled={offset + limit >= total} onClick={() => setOffset(offset + limit)}>Next</button>
          </div>
        </>
      )}
    </div>
  );
};

export default OPOActivityTab;
